// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `div.YLCkgEYtIlcHS_PPShDL{color:#fff;border:none}.nZ_X7MQsSYXXFkJgQQe1{align-items:center;gap:8px;margin-left:-2px;margin-right:-2px;padding-top:22px;display:flex}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"cropArea": `YLCkgEYtIlcHS_PPShDL`,
	"controls": `nZ_X7MQsSYXXFkJgQQe1`
};
export default ___CSS_LOADER_EXPORT___;
